import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-triangle-rounded",
  "use": "arrow-triangle-rounded-usage",
  "viewBox": "0 0 5 6",
  "content": "<symbol viewBox=\"0 0 5 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-triangle-rounded\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.667968 1.41421C0.667968 0.523309 1.74511 0.0771418 2.37507 0.707106L3.96086 2.29289C4.35139 2.68342 4.35139 3.31658 3.96086 3.70711L2.37507 5.29289C1.74511 5.92286 0.667968 5.47669 0.667968 4.58579L0.667968 1.41421Z\" fill=\"#724AE6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol